import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const heroSectionFrontBackgroundColors = [
  BackgroundColor.MIDNIGHT_BLUE,
  BackgroundColor.LIGHT_BLUE,
  BackgroundColor.PURPLE,
  BackgroundColor.BERRY,
  BackgroundColor.DARK_MINT
] as const

export type HeroSectionFrontBackgroundColor =
  (typeof heroSectionFrontBackgroundColors)[number]
